var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 42,
    viewBox: "0 0 24 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(-336 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pink_Triangle",
    "data-name": "Pink Triangle",
    d: "M0,0H0V12H12L0,0Z",
    transform: "translate(360 2) rotate(180)",
    fill: "#c7017f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hamburger",
    transform: "translate(-10 -43)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 24,
    transform: "translate(346 67)",
    fill: "none",
    stroke: "#f3f2ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 24,
    transform: "translate(346 74)",
    fill: "none",
    stroke: "#f3f2ef",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBars);
export default __webpack_public_path__ + "static/media/menu-bars.4ea74bf382ba63cafd67ed9c353e3ab1.svg";
export { ForwardRef as ReactComponent };